import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { WarehouseSelector } from "../rawData/warehouse/warehouseSelector";
import { lineItem, WarehouseKeepingViewModel } from "./warehouseKeeping-viewModel"

export class WarehouseKeepingView extends View<WarehouseKeepingViewModel>{
    GetViewUniqueId(): string {
        return "V-58CD1831-25BA-4186-B47A-8DEAAC7530B4"
    }
    loadHtml(): string {
        let element = require('./warehouseKeeping.html').default;
        let style = require('./warehouseKeeping.less');
        return element;
    }
    constructor() {
       super();
    }

    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;
    
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;


    createWarehouseKeeping(){
        this.dataContext.createWarehouseKeeping();
    }

}
